import React, { Component } from 'react'
import { Form as Formiker, Field as Fieldmik, Formik, FieldArray } from 'formik';
import { connect } from 'react-redux';

import { Form as FormUi, Button, Segment, Container } from 'semantic-ui-react';

import * as Yup from 'yup'

import AddTitleBar from '../../titleBar/add_titleBar';
import { MyInput } from '../../apiInputComponent/myInput';

import  { getTyrePosition, createVehicleType, updateTyrePosition } from '../../../redux/actions/vehicleTypeActions'


import TyrePositionDropdown from './tyrePositionDropdown';
import cogoToast from 'cogo-toast';
import DeleteAxios from '../../axiosComponent/deleteAxios'



class AddVehicleType extends Component{
    constructor(props){
        super(props);
        this.state = {
            options:[],
            tyrePositionData:[],
            vehicleTypeMasterID:''
        }
    }

    componentDidMount(){
        console.log('component did mount')
        
     
        let data = this.props.getTyrePosition()
        data.then((resp)=>{
console.log(resp,'resp')
this.setState({tyrePositionData:resp.resultSet})
        }).catch((err)=>{

        })
     
        // console.log(data.resultSet,'propsssssss')
    }

     handleDelete = () => {
        // console.log(object,'delete id')
        // setsuccess(true)
        //     let id = props.match.params.id 
        //     DeleteAxios({
        //         url: `masters/vehicleTypeTyrePositionMapping`,
        //         deleteItems: {
        //         vehicleTypeId: id,
        //         // positionId:positionId
        //     },
        //     deleted: (data) => {
        //         if (data && data.status === 1) {
        //             setTimeout(() => {
        //                 setsuccess(false)
        //                 props.agGridReact.props.reload(true)
        //             }, 500);
        //         }
        //     }
        // })

    }

    render(){
        console.log(this.props,'props')
console.log(this.state.options,"this.state.options")
console.log(this.state.tyrePositionData,"tyrePositionData")
        const initialValues = {
            vehicleTypeCode: '',
            vehicleTypeName: '',
            vehicleTypeTyre: [
                {
                    positionId: '',
                    vehicleTypeTyrePositionMapId: ''
                }
            ]
        
        }

        const updateTyrePositionType = () => {

        }


  


        const validationSchema =  Yup.object({
            vehicleTypeCode: Yup.string().required("Required"),
            vehicleTypeName: Yup.string().required("Required")
        })

        const onSubmit = (values) => {
            console.log(values,'valuessssss')
            console.log(values.vehicleTypeTyre,'values.vehicleTypeTyre')
            // this.props.createVehicleType(values)
            let vehicleTypeMasterId = this.props.createVehicleType(values)
            vehicleTypeMasterId.then((res)=>{
                // res.messege.vehicleTypeMasterId
                cogoToast.success('Vehicle Type created')
                console.log( res.message.vehicleTypeMasterId,"vehicleTypeMasterId")
                if(res.message.vehicleTypeMasterId){
                    this.setState({vehicleTypeMasterID:res.message.vehicleTypeMasterId})
                    if(values.vehicleTypeTyre.length > 0){
                        let customerNumber = localStorage.getItem('customerNo')
                        let userId = localStorage.getItem('userId')
                        values.vehicleTypeTyre.forEach((obj)=>{
                            let temp = {}
                            temp.vehicleTypeId = this.state.vehicleTypeMasterID
                            temp.positionId = obj.positionId
                            temp.customerNumber = customerNumber
                            temp.userId = userId
                            console.log(temp,'tyrePositionData obj')
                            this.props.updateTyrePosition(temp)
                        })
                    }
                    if(res.status == 204){
                        cogoToast.success(res.message)
                    }
                 

                }

            }).catch((err)=>{
                
            })
        }

        const removeId = (object) => {
console.log(object,'removed object')
        }

        // const updateList = (val) => {
        //     let updatedList = []
        //     // temp.push(object)
        //     console.log(val,'added object')
        //     console.log(this.state.tyrePositionData,'state')
        //     let temp = this.state.tyrePositionData.forEach((object) =>{
        //         val.filter((value)=>{
        //             if(object.tyrePositionId != value.positionId ){
        //                 updatedList.push(object)
        //                console.log(object,'console')
        //             }
        //         })
                
        //     })
        //     console.log(updatedList,'updatedList')
        //     this.setState({tyrePositionData:updatedList})
        // }

        return <>
            <AddTitleBar Title="Vehicle Type" LinkName="/vehicle-type" />
            <Container fluid className="m-2">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}>
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                                <Formiker>
                                    <Segment>
                                        {console.log(values,"valuessss")}
                                        <div className="ui form">
                                            <FormUi.Group inline>
                                                <FormUi.Field width={3}>
                                                    <label className="labelName">Vehicle Type Code *</label>
                                                </FormUi.Field>
                                                <FormUi.Field>
                                                    <Fieldmik
                                                        name="vehicleTypeCode"
                                                        autoComplete="off"
                                                        component={MyInput}
                                                        placeholder="Code"
                                                        error={values.vehicleTypeCode ? false : true}
                                                    />
                                                    {touched.vehicleTypeCode && errors.vehicleTypeCode ? <div className="w3-tiny w3-text-red p-bold-600">{errors.vehicleTypeCode}</div> : ''}
                                                </FormUi.Field>

                                                <FormUi.Field width={1} />

                                                <FormUi.Field width={3}>
                                                    <label className="labelName">Vehicle Type Name *</label>
                                                </FormUi.Field>
                                                <FormUi.Field>
                                                    <Fieldmik 
                                                        name="vehicleTypeName"
                                                        component={MyInput} 
                                                        error={values.vehicleTypeName ? false : true}  
                                                        placeholder="Name" 
                                                    />
                                                    {touched.vehicleTypeName && errors.vehicleTypeName ? <div className="w3-tiny w3-text-red p-bold-600">{errors.vehicleTypeName}</div> : ''}
                                                </FormUi.Field>
                                            </FormUi.Group>


                                            <FormUi.Group inline>
                                                <FormUi.Field width={3}>
                                                    <label className="labelName">Tyre Position</label>
                                                </FormUi.Field>

                                                <>
                                                    <FieldArray name="vehicleTypeTyre">
                                                        {({push, remove}) => 
                                                            <React.Fragment>
                                                                <div style={{ display: "flex", flexDirection: "column",}}>
                                                                    {values.vehicleTypeTyre && values.vehicleTypeTyre.length > 0 && values.vehicleTypeTyre.map((object, index) => (
                                                                        <FormUi.Field width={3} style={{ marginTop: "8px"}}>
                                                                    {console.log(object,"obj")}
                                                                    {/* {this.state.options.push(object.positionId)} */}
                                                                            <Fieldmik component={TyrePositionDropdown} handleDelete ={this.handleDelete}tyrePositionData={this.state.tyrePositionData} values ={ values.vehicleTypeTyre} error={values.vehicleTypeName ? false : true} name={`vehicleTypeTyre[${index}].positionId`}/>
                                                                        
                                                                        <Button 
                                                                            icon="plus" 
                                                                            color="blue"
                                                                            type="button" 
                                                                            basic 
                                                                            size="mini" 
                                                                            onClick={() =>{ push({ positionId: ''})}} />
                                                                        <Button 
                                                                            icon="trash" 
                                                                            color="red" 
                                                                            type="button"
                                                                            basic 
                                                                            disabled={index > 0 ? false : true}
                                                                            size="mini"
                                                                            onClick={() => {remove(index);removeId(object)}} />
                                                                        </FormUi.Field>
                                                                    
                                                                    ))}
                                                                </div>
                                                            </React.Fragment>
                                                        }
                                                    </FieldArray>
                                                </>
                                            </FormUi.Group>
                                        </div>
                                    </Segment>
                                    <center>
                                        <Button color="blue" type="submit">Submit</Button>
                                    </center>
                                </Formiker>
                            )
                        }
                </Formik>
            </Container>

        </>
    }
}

const mapStatetoProps = (state) => ({
    tyrePositionData: state.tyrePositionList.tyrePositionList.resultSet
  })

export default connect(null, {updateTyrePosition, getTyrePosition, createVehicleType })(AddVehicleType)